import * as config from "./config";
// import index from './react/index.jsx'
// import Suction from "./module/suction";
// import MenuTrigger from "./module/menuTrigger";

require('./module/common')
require('./module/movoto-scroll')
require('./module/modaal')
require('./module/loading')
// require('./module/suction')
// require('./module/swipter')
// require('./module/bkcurve')


// const module = [
//   MenuTrigger,
// ]

const instance = []

// グローバルで使用するクラスを自動インスタンス化
// ;[].forEach.call(module, m => {
//   instance.push(new m())
// })

window[config.namespace] = {
  instance
}
